import {isNullOrUndefined} from 'util';
import {get, has, padEnd, split} from 'lodash';
import {Pipe, PipeTransform} from '@angular/core';
import {Money} from '../../../../common/api';

@Pipe({name: 'money'})
export class MoneyPipe implements PipeTransform {

    transform(value: any | Money, currencyFirst? : boolean): string {
        if (value === undefined) {
            return '';
        }
        return this.isMoney(value)
            ? this.transformMoney(value, isNullOrUndefined(currencyFirst) || currencyFirst)
            : this.transformAmount(value);
    }

    private isMoney(value: any) {
        return has(value, 'amount')
            || has(value, 'currency_code');
    }

    private transformMoney(value: Money, currencyFirst: boolean ) {
        let amount: string = this.transformAmount(value.amount);
        let currency: string = this.transformCurrency(value.currency_code);
        if (currencyFirst) {
            return currency + ' ' + amount;
        }
        return amount + ' ' + currency;
    }

    private transformAmount(value: any): string {
        let parts: string[] = split(String(value), '.');

        let wholePart: string = get(parts, '[0]', '0');
        let fraction: string = get(parts, '[1]', '0');

        return wholePart + '.' + padEnd(fraction, 2, '0');
    }

    private transformCurrency(value: string): string {
        return isNullOrUndefined(value) ? '' : value;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/pipes/money.pipe.ts